import audio_player from '../assets/audio_player.jpg';
import background2 from '../assets/background2.jpg';
import catch_the_ball from '../assets/catch_the_ball.jpg';
import background44444 from '../assets/background44444.jpg';
import color_gusser from '../assets/color_gusser.jpg';
import dictionary from '../assets/dictionary.jpg';
import image_detector from '../assets/image_detector.jpg';
import jitendraa from '../assets/jitendraa.jpg';
import lava_webmap from '../assets/lava_webmap.jpg';
import ltr_dtr from '../assets/ltr_dtr.jpg';
import m_salary_data_collector from '../assets/m_salary_data_collector.jpg';
import motion_detector from '../assets/motion_detector.jpg';
import portrait_small from '../assets/portrait_small.jpg';
import portrait from '../assets/portrait1.png';
import re_webscrapping from '../assets/re_webscrapping.jpg';
import sc_desktop_app from '../assets/sc_desktop_app.jpg';
import score_keeper from '../assets/score_keeper.jpg';
import website_blocker from '../assets/website_blocker.jpg';
import wpf_calculator from '../assets/wpf_calculator.jpg';
import yelp_camp from '../assets/yelp_camp.jpg';
import network from '../assets/network.png';


import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import ds2 from '../assets/ds2.png';
import seng from '../assets/seng.jpeg'
import sdev from '../assets/sdev.jpeg'
import ml from '../assets/ml2.png'
import unbPort from '../assets/unbPortrait.jpeg'

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

export default {
    audio_player,
    background2,
    catch_the_ball,
    background44444,
    color_gusser,
    dictionary,
    image_detector,
    jitendraa,
    lava_webmap,
    ltr_dtr,
    m_salary_data_collector,
    motion_detector,
    portrait_small,
    portrait,
    re_webscrapping,
    sc_desktop_app,
    score_keeper,
    website_blocker,
    wpf_calculator,
    yelp_camp,
    network,
    email,
    mobile,
    api,
    cpp,
    css,
    figma,
    flutter,
    git,
    graphql,
    html,
    javascript,
    mu5,
    node,
    python,
    react,
    redux,
    sass,
    typescript,
    vue,
    about01,
    about02,
    about03,
    about04,
    profile,
    circle,
    logo,
    adidas,
    amazon,
    asus,
    bolt,
    nb,
    skype,
    spotify,
    ds2,
    seng,
    sdev,
    ml,
    unbPort
};


